export default {
    getterWorkerFeePerStoreGroupList: (state) => state.workerFeePerStoreGroupList.map((it) => ({
        ...it,
    })),
    // 추후 값 맵핑을 위해 필요함.
    getterWorkerFeePerStoreGroupOptionList: (state) => state.workerFeePerStoreGroupOptionList.map((it) => ({
        ...it,
    })),
    getterSortedWorkerFeePerStoreGroupOptionList: (state, { getterWorkerFeePerStoreGroupOptionList, }) => [
        ...getterWorkerFeePerStoreGroupOptionList,
    ]?.sort((a, b) => a.fromAmount - b.fromAmount),
    getterSelectedFeeGroupId: (state) => state.selectedFeeGroup?.id,
    getterSelectedFeeGroupName: (state) => state.selectedFeeGroup?.name,
};
